// extracted by mini-css-extract-plugin
export var closeButton = "_gt-2";
export var closeButtonIcon = "_gt-3";
export var lightboxContent = "_gt-1";
export var lightboxOverlay = "_gt-0";